import React from 'react';
import { Carousel } from 'react-bootstrap';
import firstSlide from '../../image/banner1.jpg';
import secondSlide from '../../image/banner2.jpg';
import thirdSlide from '../../image/banner3.jpg';

const ECommerceCarousel = () => {
  return (
    <Carousel interval={3000}>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={firstSlide}
          alt="First slide"
        />
      </Carousel.Item>

      <Carousel.Item>
        <img
          className="d-block w-100"
          src={secondSlide}
          alt="Second slide"
        />
      </Carousel.Item>

      <Carousel.Item>
        <img
          className="d-block w-100"
          src={thirdSlide}
          alt="Third slide"
        />
      </Carousel.Item>
    </Carousel>
  );
};

export default ECommerceCarousel;
